import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {JWTService} from 'src/app/authentication/jwt.service';
import {PasteboxService} from 'src/app/services/pastebox.service';
import {HttpErrorHandlerService} from '../../http-error-handler.service';
import {TransmissionService} from '../transmission.service';
import {RaintreeResponse} from '../../interface/raintree-response';
import {CheckTenantEmail} from 'src/app/authentication/interface/check-tenant-email';
import {VerifyToken} from 'src/app/authentication/interface/verify-token';
import {ResetPassword} from 'src/app/authentication/interface/reset-password';

@Injectable({
	providedIn: 'root'
})
export class TenantVerificationTransmissionService extends TransmissionService {

	constructor(
		_http: HttpClient,
		_httpErrorHandler: HttpErrorHandlerService,
		_jwt: JWTService,
		_pastebox: PasteboxService
	) {
		super(_http, _httpErrorHandler, _jwt, _pastebox);
	}

	public verifyTenant(
		url: string,
		payload: CheckTenantEmail,
		onPreExecute: () => void,
		onPostExecute: (response: RaintreeResponse) => void,
		onSuccess: (response: RaintreeResponse) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	) {

		this.executePostPayload(
			url,
			payload,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			false
		);
	}


	public sendEmail(
		url: string,
		payload: CheckTenantEmail,
		onPreExecute: () => void,
		onPostExecute: (response: RaintreeResponse) => void,
		onSuccess: (response: RaintreeResponse) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	) {

		this.executePostPayload(
			url,
			payload,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			false
		);
	}


	public verifyEmail(
		url: string,
		payload: VerifyToken,
		onPreExecute: () => void,
		onPostExecute: (response: RaintreeResponse) => void,
		onSuccess: (response: RaintreeResponse) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	) {

		this.executePostPayload(
			url,
			payload,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			false
		);
	}

	public sendPasswordResetEmail(
		url: string,
		payload: CheckTenantEmail,
		onPreExecute: () => void,
		onPostExecute: (response: RaintreeResponse) => void,
		onSuccess: (response: RaintreeResponse) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	) {

		this.executePostPayload(
			url,
			payload,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			false
		);
	}

	public resetPasswordRequest(
		url: string,
		payload: ResetPassword,
		onPreExecute: () => void,
		onPostExecute: (response: RaintreeResponse) => void,
		onSuccess: (response: RaintreeResponse) => void,
		onFailure: (error: string) => void,
		onComplete: () => void,
	) {

		this.executePostPayload(
			url,
			payload,
			onPreExecute,
			onPostExecute,
			onSuccess,
			onFailure,
			onComplete,
			false
		);
	}
}
